<template>
  <v-row dense>
    <v-col cols="12">
      <v-select
        v-model="form.address_id"
        name="address_id"
        item-text="name"
        item-value="id"
        :items="addressesList"
        :readonly="readonly"
        :label="$t('LINKED_ADDRESSES.ITEM')"
        :rules="getRulesByName('address_id')"
        :error-messages="errors.get('address_id')"
        clearable
        @change="updateValue('address_id', $event)"
      />
    </v-col>
    <v-col cols="12">
      <v-text-field
        v-model="form.per_address"
        name="per_address"
        :counter="100"
        :readonly="readonly"
        :label="$t('LINKED_ADDRESSES.PER_ADDRESS')"
        :rules="getRulesByName('per_address')"
        :error-messages="errors.get('per_address')"
        @input="updateValue('per_address', $event)"
      />
    </v-col>
    <v-col cols="12">
      <v-select
        v-model="form.type_id"
        name="type_id"
        item-text="name"
        item-value="id"
        :items="addressesTypes"
        :readonly="readonly"
        :label="$t('ITEM.TYPE')"
        :rules="getRulesByName('type_id')"
        :error-messages="errors.get('type_id')"
        clearable
        @change="updateValue('type_id', $event)"
      />
    </v-col>
  </v-row>
</template>

<script>
import { maxLength, notEmpty } from '@/modules/_global/variables/rules.js';
import formEditable from '@/modules/_global/mixins/form-editable';
import { mapActions } from 'vuex';

export default {
  name: 'AddressLinkedForm',

  mixins: [formEditable],

  props: {
    personId: {
      type: Number,
      required: true
    }
  },

  data() {
    return {
      form: {
        address_id: null,
        per_address: '',
        type_id: null
      },
      rules: {
        address_id: [notEmpty],
        per_address: [maxLength(100)],
        type_id: [notEmpty]
      },
      addresses: [],
      addressesTypes: []
    };
  },

  computed: {
    addressesList() {
      return this.addresses.map(({ id, street, zip, city }) => ({
        id,
        name: [street, zip, city].join(', ')
      }));
    }
  },

  mounted() {
    this.getAddresses({
      personId: this.personId
    }).then(({ data }) => {
      this.addresses = data.data;
    });

    this.getAddressesTypes().then(({ data }) => {
      this.addressesTypes = data.data;
    });
  },

  methods: {
    ...mapActions('person', ['getAddresses', 'getAddressesTypes'])
  }
};
</script>

<style scoped></style>
